import { IconProps } from "../../../components/Input/types";

const WeChatV2Icon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 12"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M5.07.276C2.27.276 0 2.194 0 4.56c0 1.29.683 2.452 1.751 3.238a.34.34 0 0 1 .124.388l-.227.863c-.011.04-.028.082-.028.124a.17.17 0 0 0 .17.172.2.2 0 0 0 .097-.031l1.11-.65a.5.5 0 0 1 .418-.057 6 6 0 0 0 1.655.235c.16 0 .316-.016.473-.03-.5-1.503.091-2.9 1.127-3.76.993-.825 2.264-1.154 3.414-1.072C9.748 1.89 7.636.276 5.07.276M3.375 2.495c.374 0 .677.308.677.688a.68.68 0 0 1-.677.687.68.68 0 0 1-.678-.687c0-.38.303-.689.678-.689m3.39 0c.375 0 .678.308.678.688a.68.68 0 0 1-.677.687.683.683 0 0 1-.678-.687c0-.38.303-.688.678-.688m3.116 1.672c-1.049-.03-2.186.299-3.08 1.042-1.004.833-1.568 2.17-1.039 3.628.55 1.431 2.139 2.467 4.016 2.467.482 0 .946-.07 1.377-.196a.42.42 0 0 1 .349.048l.924.54a.16.16 0 0 0 .082.028c.078 0 .14-.065.14-.144 0-.035-.014-.07-.023-.104l-.19-.719a.3.3 0 0 1-.014-.09.29.29 0 0 1 .117-.233C13.43 9.78 14 8.812 14 7.738c0-1.872-1.71-3.405-3.883-3.551v-.001c-.078-.006-.157-.016-.237-.018m-1.476 1.91a.57.57 0 0 1 .565.573.57.57 0 0 1-.565.573.57.57 0 0 1-.566-.573.57.57 0 0 1 .566-.573m2.825 0a.57.57 0 0 1 .566.573.57.57 0 0 1-.566.573.57.57 0 0 1-.565-.573.57.57 0 0 1 .565-.573"
      ></path>
    </svg>
  );
};

export default WeChatV2Icon;
